import React from 'react';
import { FormGroup, FormControl, InputGroup } from 'react-bootstrap';


export default class CharWithIconAddon extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            errors: false,
            touched_and_blank: false,
            value: '',
            class_names: '',
        }
    }

    componentDidMount = () => {
        //console.log('CharField componentDidMount');
        this.setState({value: this.props.editingInstance[this.props.field_id]});
        if (this.props.focus === this.props.field_id) {
            $(`#${this.props.field_id}`).focus();
        }
    }

    onChange = (e) => {
        let data_key = e.target.name;
        //let value = $.trim(e.target.value);
        let value = e.target.value;
        this.setState({value});

        // if (this.saveFieldTimer) {
        //     clearTimeout(this.saveFieldTimer);
        // }
        //
        // this.saveFieldTimer = setTimeout(() => {
        //   this.props.onSelectChange(this.props.field_id, value);
        // }, 750);
        this.props.onSelectChange(this.props.field_id, value);
    }

    render() {
        return (
          <FormGroup controlId='largeinput horizontalpassword' bsSize="large">
              <InputGroup>
                  <InputGroup.Addon style={this.props.input_group_addon_style}>
                      <i className={this.props.icon_class} style={this.props.style}/>
                  </InputGroup.Addon>
                  <FormControl
                      type={this.props.type}
                      id={`${this.props.field_id}`}
                      placeholder={this.props.field_id}
                      required
                      autoFocus={this.props.autoFocus}
                      value={this.state.value}
                      onChange={this.onChange}
                  />
              </InputGroup>
          </FormGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/char_with_icon_addon.js